export default __webpack_public_path__ + "static/media/quest-ans.4d9e1dd5.svg";